const selectors = {
  main: 'subscription-widget-main',
  selectedOption: '.subscription-widget__item[data-selected="true"]',
  allOptions: '.subscription-widget__item',
  form: 'form[action="/cart/add"]',
  oldWidgets: '.sealsubs-target-element',
  submitButtons: '#featuredProductTabs button[type="submit"]'
}

class SubscriptionWidget extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      main: document.getElementById(selectors.main),
      allOptions: document.querySelectorAll(selectors.allOptions),
      selectedOption: document.querySelector(selectors.selectedOption),
      oldWidgets: document.querySelectorAll(selectors.oldWidgets),
      forms: document.querySelectorAll(selectors.form),
      submitButtons: document.querySelectorAll(selectors.submitButtons)
    };

    this.chooseQty = 0;
    this.attachEventListeners = this.attachEventListeners.bind(this);
    this.removeOldWidget = this.removeOldWidget.bind(this);
    this.updateFormsData = this.updateFormsData.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this); // Bind the form submit handler

    document.addEventListener('DOMContentLoaded', this.attachEventListeners);
    document.addEventListener('DOMContentLoaded', this.removeOldWidget);
    document.addEventListener('DOMContentLoaded', this.updateFormsData);
  }

  attachEventListeners() {
    this.elements.allOptions.forEach(option => {
      option.addEventListener('click', (event) => {
        this.selectOption(event);
      });
    });

    this.elements.submitButtons.forEach(form => {
      form.addEventListener('click', this.handleFormSubmit);
    });
  }

  handleFormSubmit(event) {
    // event.preventDefault(); // Prevent the default form submission

    // const form = event.target.closest(selectors.form); // Get the parent form of the button
    // const formData = new FormData(form); // Get the form data
    // const formDataEntries = Array.from(formData.entries());

    // // Filter the form data to keep only the first 'quantity'
    // const filteredData = formDataEntries.reduce((acc, [key, value]) => {
    //   if (key === "quantity") {
    //     // If 'quantity' is already in the accumulator, ignore it
    //     if (!acc.some(([k]) => k === "quantity")) {
    //       acc.push([key, value]);
    //     }
    //   } else {
    //     acc.push([key, value]);
    //   }
    //   return acc;
    // }, []);
  }

  selectOption(event) {
    const target = event.target.closest(selectors.allOptions);
    const targetOption = target.getAttribute('data-option');
    const allTargets = document.querySelectorAll(selectors.allOptions + `[data-option=${targetOption}]`);
    if (!target) return;

    this.elements.allOptions.forEach(option => option.removeAttribute('data-selected'));
    allTargets.forEach(element => {
      element.setAttribute('data-selected', true);
    });

    this.updateFormsData();
  }

  updateFormsData() {
    const selectedOption = this.getSelectedOption();
    if (!selectedOption) return;

    const selectedData = this.getSelectedData(selectedOption);
    this.clearOldFormsData();

    if (this.elements.forms.length === 0) return;
    var curr_selected_price = selectedOption.querySelector('.subscription-widget__item--price').innerHTML;
    var curr_price_elems = document.querySelectorAll('.price-list.sale-price');
    curr_price_elems.forEach(function(elem) {
      elem.innerHTML = curr_selected_price;
    });

    this.elements.forms.forEach(form => {
      selectedData.forEach(element => {
        const elementToAppend = element.cloneNode(true);
        form.appendChild(elementToAppend);
      });
    });
  }

  getSelectedOption() {
    return document.querySelector(selectors.selectedOption);
  }

  getSelectedData(element) {
    if (!element) return [];
  
    const quantity = element.getAttribute('data-quantity');
    const sellingPlanId = element.getAttribute('data-selling-plan-id');
  
    const quantityInput = document.createElement('input');
    quantityInput.type = 'hidden';
    quantityInput.name = 'quantity';
    quantityInput.value = quantity;
  
    if (sellingPlanId) {
      const sellingPlanIdInput = document.createElement('input');
      sellingPlanIdInput.type = 'hidden';
      sellingPlanIdInput.name = 'selling_plan';
      sellingPlanIdInput.value = sellingPlanId;
  
      return [quantityInput, sellingPlanIdInput];
    }
  
    return [quantityInput];
  }

  clearOldFormsData() {
    const inputsToRemove = ['quantity', 'selling_plan'];
  
    if (this.elements.forms.length === 0) return;
  
    this.elements.forms.forEach(form => {
      inputsToRemove.forEach(name => {
        const input = form.querySelector(`input[name="${name}"]`);
        if (input) form.removeChild(input);
      });
    });
  }

  async removeOldWidget() {
    await this.checkForOldWidgets();
    if (this.elements.oldWidgets.length === 0) return;
  
    this.elements.oldWidgets.forEach(element => element.remove());
  }
  
  checkForOldWidgets() {
    return new Promise((resolve) => {
      const maxAttempts = 15;
      let attempts = 0;
      const intervalId = setInterval(() => {
        const oldWidgets = document.querySelectorAll(selectors.oldWidgets);
        attempts++;
  
        if (oldWidgets.length > 0) {
          this.elements.oldWidgets = oldWidgets;
          clearInterval(intervalId);
          resolve();
        } else if (attempts >= maxAttempts) {
          clearInterval(intervalId);
          resolve();
        }
      }, 200);
    });
  }  
}

customElements.define('subscription-widget', SubscriptionWidget);





















